export default function About() {
  return (
    <main className="mx-auto max-w-3xl px-6 py-16 md:py-24 text-foreground">
      <header className="mb-12 border-b border-border pb-8">
        <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-8">
          <div>
            <h1 className="text-4xl md:text-5xl font-semibold tracking-tight mb-3">
              About
            </h1>
            <p className="text-base text-muted-foreground">
              Last updated May 4, 2026
            </p>
          </div>
          <img
            src="/sy-sipperly-headshot.jpg"
            alt="Sy Sipperly, Founder of LegacyLens AI"
            className="w-48 md:w-52 h-48 md:h-52 rounded-2xl object-cover shrink-0"
          />
        </div>
      </header>

      <section className="mb-16">
        <div className="space-y-5 text-lg leading-relaxed">
          <p>I'm not a Silicon Valley founder. At least not yet.</p>
          <p>
            For the past 20+ years I've been a commercial pilot by trade.
            I've lived in New York, Los Angeles, Beijing, Hong Kong, and a
            few other places along the way. I appreciate cities, but I'm
            drawn to the land — growing things over time, cultivating for
            the long term, working continually on making something better.
            Whether that's my chestnut tree farm, or this company.
          </p>
          <p>
            LegacyLens started in a different place than where it landed.
          </p>
          <p>
            The first idea was a memorial product — using technology to
            preserve someone's voice and presence after they were gone. I
            worked with a project manager on it for a short bit and
            eventually decided not to proceed. The idea wasn't quite right,
            the technology I needed wasn't quite there, and I momentarily
            shelved it.
          </p>
          <p>
            A month later I was visiting my parents, still turning the
            problem over in my head, trying to figure out what tech actually
            existed for what I had in mind. I hadn't found it exactly. And
            at some point during that visit I just thought — screw it. I'm
            capturing them now, the best I can. Their voice, their 3D
            capture, their presence. While I still have the chance. I may
            never see them again.
          </p>
          <p>
            That decision was personal, not commercial. But it clarified
            everything about the project. The thing I needed for myself
            turned out to be the thing the product was actually about:
            capturing someone <em>while they're still here</em> — fully
            present, fully consenting, telling their own story in their own
            words. Not after. Now.
          </p>
          <p>
            That's what LegacyLens is. It lets people decide, while they're
            still here, how they'll be remembered — and gives their family
            a way to experience their story in the future. We turn static
            records into living experiences that future generations can
            return to and connect with.
          </p>
          <p className="text-base text-muted-foreground">
            <em>A formal advisory board is in development.</em>
          </p>
        </div>
      </section>

      <div className="mt-16 pt-8 border-t border-border">
        <address className="not-italic text-base text-muted-foreground leading-relaxed">
          <div className="font-semibold text-foreground">LegacyLens AI</div>
          <div>447 Broadway, 2nd Floor #1240</div>
          <div>New York, NY 10013</div>
          <div className="mt-3">Founder: Sy Sipperly</div>
        </address>
      </div>
    </main>
  );
}
